import styles from './popup-sign-iframe.module.css';
import classNames from 'classnames/bind';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RegularSpinner from '../../Spinner/RegularSpinner';

const cx = classNames.bind(styles);

interface PopupSignIframeProps {
  url: string | URL;
  onLoad?: () => void;
  onClose?: () => void;
  isOpen?: boolean;
  quoteData?: {
    quoteId: string;
    accessToConsentSignDocument: boolean;
  };
}

export const PopupSignIframe: FC<PopupSignIframeProps> = ({ url, onClose, isOpen }) => {
  if (!isOpen) return null;

  const [ shouldLoadIframe, setShouldLoadIframe ] = useState<boolean>(false);

  useEffect(() => {
    setShouldLoadIframe(true);
  }, [])

  url = url.toString();
  const { t } = useTranslation();
  const [ isLoading, setIsLoading ] = useState<boolean>(true);

  const onLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className={cx("popup-overlay")}>
      <div className={cx("popup-content")}>
        <button className={cx("close-button")} onClick={onClose}>{t('pages.documentos.signPopup.close')}✕</button>
        {
          isLoading &&
          <div style={{ marginTop: '100px'}}>
            <RegularSpinner />
          </div>
        }
        { shouldLoadIframe &&
          <iframe
            src={url}
            title="Lura Care"
            className={cx("popup-iframe")}
            allowFullScreen
            onLoad={onLoad}
            style={{ visibility: isLoading ? 'hidden' : 'visible'}}
          />
        }
      </div>
    </div>
  );

  // return <iframe src={url} className={cx('iframe')} onLoad={onLoad}></iframe>;
};
